import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import {
    getYouTubeVideoKey,
    isNullOrWhiteSpace
} from '@classifieds-sell/shared';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-video-section',
    templateUrl: './property-video-section.component.html',
    styleUrls: ['./property-video-section.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PropertyVideoSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    addVideoText = 'Add video';
    removeVideoText = 'Remove video';

    inputDisabled = false;
    buttonTitle = this.addVideoText;

    isProcessing = false;
    hasError = false;

    private _youTubeUrl = 'https://www.youtube.com/embed/';
    safeYouTubeVideoUrl: SafeResourceUrl;
    originalYouTubeVideoKey: string;
    previewYouTubeVideoUrl = false;

    @ViewChild('propertyVideoSectionForm')
    propertyVideoSectionForm: NgForm;

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _sanitizer: DomSanitizer
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            if (
                (this.draftData?.propertyPhotos?.youTubeVideoKey || '').length >
                0
            ) {
                const youTubeVideoKey =
                    this.draftData?.propertyPhotos?.youTubeVideoKey;
                const safeYouTubeVideoUrl =
                    this._sanitizer.bypassSecurityTrustResourceUrl(
                        `${this._youTubeUrl}${this.draftData?.propertyPhotos?.youTubeVideoKey}`
                    );
                if (this.originalYouTubeVideoKey !== youTubeVideoKey) {
                    this.safeYouTubeVideoUrl = safeYouTubeVideoUrl;
                    this.originalYouTubeVideoKey =
                        this.draftData?.propertyPhotos?.youTubeVideoKey;

                    if (!this.previewYouTubeVideoUrl) {
                        this.previewYouTubeVideoUrl = true;
                    }
                }
                this.inputDisabled = true;
                this.buttonTitle = this.removeVideoText;
            } else {
                this.inputDisabled = false;
                this.buttonTitle = this.addVideoText;
            }
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true; // allow user to progress through form even if the video link is broken
    }

    dirty(): boolean {
        if (this.propertyVideoSectionForm.form.disabled) {
            return this.propertyVideoSectionForm.form.controls.youtubeVideo
                .dirty;
        }
        return this.propertyVideoSectionForm.form.dirty;
    }

    validateVideo(): void {
        const videoKey = getYouTubeVideoKey(
            this.draftData.propertyPhotos.youTubeVideoUrl
        );

        if (videoKey.length > 0) {
            this.draftData.propertyPhotos.youTubeVideoKey = videoKey;
            this.updateState();
        } else {
            this.propertyVideoSectionForm?.form?.controls?.youtubeVideo.setErrors(
                { incorrect: true }
            );

            this.previewYouTubeVideoUrl = false;
            this.hasError = true;
        }
        this.isProcessing = false;
    }

    onVideoButtonClick(): void {
        this.hasError = false;
        if (this.buttonTitle === this.addVideoText) {
            this.isProcessing = true;
            this.validateVideo();
        } else if (this.buttonTitle === this.removeVideoText) {
            this.draftData.propertyPhotos.youTubeVideoKey = null;
            this.draftData.propertyPhotos.youTubeVideoUrl = null;
            this.safeYouTubeVideoUrl = null;
            this.originalYouTubeVideoKey = null;
            this.previewYouTubeVideoUrl = false;
            this.updateState();
        }
        this._changeDetectorRef.markForCheck();
    }

    onInputChange(value: string) {
        if (isNullOrWhiteSpace(value)) {
            this.hasError = false;
        }
    }

    updateState() {
        this.propertyVideoSectionForm.form.markAllAsTouched();
        this.propertyVideoSectionForm.form.markAsDirty();
        this.publish();
    }
}
